import { resolveRoleShellMode } from "@/coquille-bridge";

/**
 * Résout le mode shell Karaté incluant Sempai (assistant) et Parent.
 * @param {string} activeRole
 * @param {{ isAuthenticated?: boolean, pathname?: string }} ctx
 * @returns {'public'|'auth'|'admin'|'manager'|'assistant'|'parent'|'player'}
 */
export function resolveKarateShellMode(activeRole, ctx = {}) {
  const { pathname = "" } = ctx;
  if (pathname.startsWith("/connexion") || pathname.startsWith("/demande-compte")) return "auth";
  if (!ctx.isAuthenticated || activeRole === "guest") return "public";

  const role = activeRole === "admin" ? "hanshi" : activeRole;
  if (role === "assistant") return "assistant";
  if (role === "parent") return "parent";

  const base = resolveRoleShellMode(role, ctx);
  return base === "player" ? "player" : base;
}

/**
 * Mode passé à GsdConnectedShell (admin | manager | player | public | auth).
 * @param {ReturnType<typeof resolveKarateShellMode>} karateMode
 */
export function toGsdShellMode(karateMode) {
  if (karateMode === "assistant") return "manager";
  if (karateMode === "parent") return "player";
  return karateMode;
}
